@use '@/styles/tokens' as *;

// Figma node 219:327388 — three equal columns in one bordered card.

.card {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-4);
  padding: var(--space-5) var(--space-4);
  border: 1px solid var(--border-subtle);
  border-radius: $radius-xl;
  background: var(--surface-card);
}

.metric {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.label {
  margin: 0;
  font-size: $font-size-14;
  line-height: 1.3;
  color: var(--text-tertiary);
}

.reading {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin: 0;
}

.value {
  font-family: $font-family-heading;
  font-size: $font-size-28;
  font-weight: $font-weight-medium;
  line-height: 1;
  color: var(--text-primary);
}

.unit {
  font-size: $font-size-14;
  line-height: 1;
  color: var(--text-muted);
}

.dot {
  align-self: center;
  width: 7px;
  height: 7px;
  margin-left: 4px;
  border-radius: 50%;
  background: $color-success-700;
}
